import * as React from "react";
import {
  container,
  styledContainer,
  styledSubtitle,
  title,
} from "./FeaturedProperties.module.scss";

export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};
export const StyledContainer: React.FC<any> = (props) => {
  return <div className={styledContainer}>{props.children}</div>;
};
export const StyledSubtitle: React.FC<any> = (props) => {
  return (
    <div className={styledSubtitle} style={{ color: props.color || "inherit" }}>
      {props.children}
    </div>
  );
};
export const Title: React.FC<any> = (props) => {
  if (props.node.titelNodeType === "h2") {
    return <h2 className={title}>{props.node.field_title}</h2>;
  } else {
    return <h3 className={title}>{props.node.field_title}</h3>;
  }
};
